<section>

    <div class="grid grid-cols-4 gap-5">

        <div class="col-span-3 ">

            <app-video-player></app-video-player>

            <ul class="flex items-center justify-between mt-5">
                <li class="font-semibold flex gap-2 items-center"><i class="ri-team-line"></i> 15k Views</li>
                <li>
                    <ul class="flex items-center gap-2">
                        <li><button class="btn  rounded-full"><i class="ri-thumb-up-fill"></i> 845</button></li>
                        <li><button class="btn  rounded-full"><i class="ri-thumb-down-line"></i> 15</button></li>
                    </ul>
                </li>
            </ul>
            <h1 class="text-3xl mt-2 capitalize font-medium">introduction to C++ programming</h1>
            <p class="mt-2 line-clamp-2  text-zinc-500">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Placeat, eaque quod ipsam dolores odio aspernatur ullam repellat. Facere nobis quidem eum cum sapiente saepe et voluptatum natus, error ducimus aperiam.</p>
            

            <div class="mt-10">
                <p class="text-lg font-semibold">Comments (256)</p>
                <hr class="my-3">

                <div class="flex items-start gap-5 mt-5">
                    <span>
                        <img class="w-10 h-10 rounded-full object-cover" src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80" alt="">
                    </span>
                    <div class="flex items-end gap-2 w-full">
                        <textarea type="text" placeholder="Type here" class="textarea textarea-bordered w-full" ></textarea>
                        <button class="btn btn-neutral rounded-full">Comment</button>
                    </div>
                </div>

                <ul class="mt-10 flex flex-col gap-10">

                    @for (i of comments; track $index) {

                        <li class="flex items-start gap-5">
                            <div class="w-8 h-8 flex-shrink-0">
                                <img class="w-full h-full rounded-full object-cover" src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80" alt="Description">
                            </div>
                            <span class="text-sm">
                                <p class=" font-semibold">{{i.name}} <span class="text-zinc-500 font-normal">{{i.date | date}}</span> </p>
                                <span class="mt-2">{{i.message}}</span>
                            </span>
                        </li>
                    }

                </ul>


            </div>



        </div>
        <div class="col-span-1 h-full overflow-y-auto ">

            <p class="font-semibold text-lg capitalize">upcoming video</p>

            <ul class="grid grid-cols-1 gap-5 mt-5">

                @for (i of upcoming_video; track $index) {
                <li class=" bg-white border rounded-lg p-3 w-full group hover:bg-zinc-200 transition duration-150">
                    <a>
                        <img class="w-full h-[8rem] object-cover rounded-lg" src="{{i.img}}" alt="">
                        <p class="mt-2 font-medium line-clamp-2">{{i.title}}</p>
                        <small class="text-zinc-500">views 35k</small>
                    </a>

                </li>
                }
            </ul>



        </div>

    </div>

</section>